import { Component } from '@angular/core';
import { LoginCard } from '@cfp/shared/ui/login';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cfp-logged-out-page',
  templateUrl: './logged-out-page.html',
  imports: [LoginCard, TranslateModule]
})
export class LoggedOutPage {}
